import {
  FestivalEventLocationCopy,
  FestivalEventLocationInfo,
  FestivalEventLocationText,
  FestivalEventLocationWrapper,
} from "./style";
import { useEffect } from "react";
import { renderToString } from "react-dom/server";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import StoreMarker from "../../../../../../../components/StoreMarker";
import useQuickButtons from "../../../../../../../hooks/useQuickButtons";

const RabbitFestivalEventLocation = () => {
  const { event } = useRabbitFestivalContext();
  const { openMap } = useQuickButtons();

  useEffect(() => {
    if (!event || !event.tournament.competition) return;
    const mapDiv = document.getElementById("map") as HTMLDivElement;
    const lat = event.tournament.competition.lat;
    const lon = event.tournament.competition.lon;

    const NaverMaps = window.naver.maps;
    const map = new NaverMaps.Map(mapDiv, {
      center: new NaverMaps.LatLng(lat, lon),
      tileSpare: 3,
    });

    new NaverMaps.Marker({
      position: new NaverMaps.LatLng(lat, lon),
      map: map,
      title: event.tournament.competition.location,
      icon: {
        content: renderToString(
          <StoreMarker
            selected
            pubType="FRANCHISE"
            name={event.tournament.competition.location}
          />
        ),
        anchor: new NaverMaps.Point(0, 30),
      },
    });
  }, [event]);

  const handleCopy = () => {
    if (!event || !event.tournament.competition) return;
    const competition = event.tournament.competition;
    const map = {
      lat: competition.lat,
      lon: competition.lon,
      cafeName: competition.location,
      newAddress: competition.address,
      detailAddress: competition.detailAddress || "",
    };
    openMap("copy", map);
  };

  return (
    <FestivalEventLocationWrapper>
      <div className="title">위치</div>
      <div id="map" />
      <FestivalEventLocationInfo>
        <FestivalEventLocationText>
          <div className="name">{event?.tournament.competition?.location}</div>
          <div className="address">
            {event?.tournament.competition?.address}{" "}
            {event?.tournament.competition?.detailAddress}
          </div>
        </FestivalEventLocationText>
        <FestivalEventLocationCopy onClick={handleCopy}>
          <img src="/image-web/rabbit/copy.png" alt="copy" />
          복사
        </FestivalEventLocationCopy>
      </FestivalEventLocationInfo>
    </FestivalEventLocationWrapper>
  );
};
export default RabbitFestivalEventLocation;
